var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCliALx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.2 19.1H17V62.8H84.2V19.1Z",
    fill: "url(#paint0_linear_2_412)",
    stroke: "white",
    strokeWidth: 0.7549
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1999 20.1H17.5999V62.4H83.1999V20.1Z",
    stroke: "#9E9E9E",
    strokeWidth: 0.2602
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1999 20.1H17.5999V62.4H83.1999V20.1Z",
    stroke: "#545454",
    strokeWidth: 0.2602
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 18.5L16.2999 63.3L21.9 63.4L22 65.4H49.7999L49.7 63.4L66.5 63.3V65.4H78.8L78.6999 63.4H84.8V18.5H16.2ZM17.5 20.1H83.3V62.3H17.5V20.1Z",
    fill: "#2A4E69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3 80C98.3 80 98 80.9 97.1 81.5H2.89995C2.89995 81.5 1.69995 81 1.69995 80.2C1.69995 79.3 4.19995 79.1 4.19995 79.1H97.5C97.5 79.1 98.3 79.3 98.3 80Z",
    fill: "#2A4E69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4 66L97.4 77.3C97.4 77.3 98.3 78.1 98.3 80L1.69995 80.2C1.69995 80.2 1.99995 77.8 2.99995 77.1C4.09995 76.4 15.7 66.1 15.7 66.1L84.4 66Z",
    fill: "#2A4E69"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 71.8L17.7998 67.4L82.4998 67.3L86.7998 71.8H13.2998Z",
    fill: "#E8F0F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3999 67.5L86.3999 71.7H13.6999L17.7999 67.6L82.3999 67.5ZM82.5999 67.2L17.7999 67.3L12.8999 72H87.1999L82.5999 67.2Z",
    fill: "#294F69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9 73L62.0999 75.3H42.7L43.4 73H60.9Z",
    fill: "#E8F0F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6999 65.6C49.6999 66.2 49.3999 66.6 50.3999 66.6H65.4999C66.4999 66.6 66.3999 66.1 66.3999 65.4C66.3999 64.8 66.4999 64.2 65.4999 64.2H50.3999C49.3999 64.3 49.6999 65 49.6999 65.6Z",
    fill: "#2A4E69"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6998 65.6C15.6998 66.2 15.5998 66.6 15.9998 66.6H21.5998C21.9998 66.6 21.9998 66.1 21.9998 65.4C21.9998 64.8 21.9998 64.2 21.5998 64.2H15.9998C15.5998 64.3 15.6998 65 15.6998 65.6Z",
    fill: "#2A4E69"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7999 65.6C78.7999 66.2 78.6999 66.6 79.0999 66.6H84.2999C84.5999 66.6 84.5999 66.1 84.5999 65.4C84.5999 64.8 84.5999 64.2 84.2999 64.2H78.9999C78.6999 64.3 78.7999 65 78.7999 65.6Z",
    fill: "#2A4E69"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1999 68H83.0999L83.1999 67.8H17.0999L17.1999 68ZM17.1999 68H83.0999V67.8H17.0999L17.1999 68Z",
    fill: "#294F69"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2999 68.9H84L84.0999 68.7H16.2999V68.9ZM16.2999 68.9H84L84.0999 68.7H16.2L16.2999 68.9Z",
    fill: "#294F69"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2999 70H84.9999L85.0999 69.8H15.1999L15.2999 70ZM15.2999 70H84.9999L85.0999 69.8H15.0999L15.2999 70Z",
    fill: "#294F69"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2999 71H85.9999L86.0999 70.8H14.0999L14.2999 71ZM14.2999 71H85.9999L86.0999 70.8H14.0999L14.2999 71Z",
    fill: "#2A4E69"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3274 46.168C27.5621 46.168 26.8574 45.9907 26.2134 45.636C25.5694 45.2813 25.0514 44.7587 24.6594 44.068C24.2767 43.368 24.0854 42.5093 24.0854 41.492C24.0854 40.484 24.2814 39.6253 24.6734 38.916C25.0747 38.1973 25.6021 37.6513 26.2554 37.278C26.9181 36.8953 27.6321 36.704 28.3974 36.704C28.9854 36.704 29.5127 36.8253 29.9794 37.068C30.4461 37.3013 30.8334 37.5767 31.1414 37.894L30.0494 39.21C29.8161 38.9953 29.5687 38.8227 29.3074 38.692C29.0554 38.552 28.7661 38.482 28.4394 38.482C28.0287 38.482 27.6507 38.5987 27.3054 38.832C26.9694 39.0653 26.6987 39.4013 26.4934 39.84C26.2974 40.2787 26.1994 40.806 26.1994 41.422C26.1994 42.3553 26.4001 43.0833 26.8014 43.606C27.2027 44.1287 27.7394 44.39 28.4114 44.39C28.7847 44.39 29.1161 44.306 29.4054 44.138C29.7041 43.97 29.9654 43.7693 30.1894 43.536L31.2814 44.824C30.5161 45.72 29.5314 46.168 28.3274 46.168ZM32.6678 46V36.872H34.7258V44.264H38.3378V46H32.6678ZM39.9139 46V36.872H41.9719V46H39.9139ZM43.6489 43.186V41.73H47.0929V43.186H43.6489ZM50.9153 41.38L50.6913 42.22H52.6373L52.4273 41.38C52.306 40.9227 52.18 40.4373 52.0493 39.924C51.928 39.4107 51.8066 38.916 51.6853 38.44H51.6293C51.5173 38.9253 51.4006 39.4247 51.2793 39.938C51.1673 40.442 51.046 40.9227 50.9153 41.38ZM47.6113 46L50.4673 36.872H52.9453L55.8013 46H53.6173L53.0573 43.83H50.2713L49.7113 46H47.6113ZM56.3227 43.186V41.73H59.7667V43.186H56.3227ZM61.4471 46V36.872H63.5051V44.264H67.1171V46H61.4471ZM67.7692 46L70.3032 41.31L67.9232 36.872H70.2192L71.0172 38.594C71.1199 38.7993 71.2226 39.0233 71.3252 39.266C71.4372 39.5087 71.5539 39.7747 71.6752 40.064H71.7312C71.8339 39.7747 71.9319 39.5087 72.0252 39.266C72.1279 39.0233 72.2259 38.7993 72.3192 38.594L73.0472 36.872H75.2452L72.8792 41.408L75.3992 46H73.1032L72.1932 44.138C72.0812 43.8953 71.9692 43.6573 71.8572 43.424C71.7546 43.1813 71.6379 42.92 71.5072 42.64H71.4512C71.3486 42.92 71.2459 43.1813 71.1432 43.424C71.0406 43.6573 70.9379 43.8953 70.8352 44.138L69.9812 46H67.7692Z",
    fill: "#2A4E69"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_412",
    x1: 16.9732,
    y1: 40.9145,
    x2: 84.1644,
    y2: 40.9145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliALx);
export default __webpack_public_path__ + "static/media/cli-a-lx.66f4e41f06f30b24423d698bdb1f34ea.svg";
export { ForwardRef as ReactComponent };